export default "__VITE_ASSET__a684e399__"